// Build-time config from Vite env vars. These values are public client config, not secrets.
import { PLACEHOLDER_PROJECT_ID } from "./lib/firebaseEnv";

/** Console config. */
export interface ConsoleConfig {
  apiBaseUrl: string;
  cargoBaseUrl: string;
  /** Host name of the OCI registry, for docker login (ADR-0033 section 5). Staging: oci-staging.prego.k8skill.com. */
  ociHost: string;
  /** Host name of the Go module proxy, for GOPROXY (ADR-0038 section 2). Staging: go-staging.prego.k8skill.com. */
  goHost: string;
  stsUrl: string;
  subjectAudience: string;
  firebase: { projectId: string; apiKey: string; authDomain: string };
  authEmulatorUrl: string | null;
}

/** Default STS URL, the same as the credential provider default (docs/credential-provider.md). */
export const DEFAULT_STS_URL = "https://sts.prego.k8skill.com/v1/sts/token";

/** Reads config from import.meta.env with production defaults. */
export function loadConfig(env: Record<string, string | undefined> = import.meta.env): ConsoleConfig {
  return {
    apiBaseUrl: env.VITE_API_BASE_URL || "https://sts.prego.k8skill.com",
    cargoBaseUrl: env.VITE_CARGO_BASE_URL || "https://cargo.prego.k8skill.com",
    ociHost: ociHost(env.VITE_OCI_HOST || "oci.prego.k8skill.com"),
    goHost: ociHost(env.VITE_GO_HOST || "go.prego.k8skill.com"),
    stsUrl: env.VITE_STS_URL || DEFAULT_STS_URL,
    subjectAudience: env.VITE_SUBJECT_AUDIENCE || "prego.k8skill.com",
    firebase: {
      projectId: env.VITE_FIREBASE_PROJECT_ID || PLACEHOLDER_PROJECT_ID,
      apiKey: env.VITE_FIREBASE_API_KEY || "",
      authDomain: env.VITE_FIREBASE_AUTH_DOMAIN || "",
    },
    authEmulatorUrl: env.VITE_FIREBASE_AUTH_EMULATOR_URL || null,
  };
}

/** Accepts a host name or a URL and returns the host (with a port, if any), as docker login wants it. */
export function ociHost(value: string): string {
  return value
    .trim()
    .replace(/^[a-z]+:\/\//i, "")
    .replace(/\/.*$/, "");
}
